/**
 * A function that recive an array and return a new array with unique values.
 * @param {string[]} array of duplucate values
 * @returns {string[]} array of unique values
 */
export const uniqueArray = <T extends unknown>(arr?: T[]) => {
  if (!arr) return [];

  return arr.filter((element, index) => arr.indexOf(element) === index);
};

export const uniqueArrayWithComparator = <T extends unknown>(
  arr: T[],
  comparator: (itemA: T, itemB: T) => boolean
) => {
  const uniqueArr: T[] = [];

  arr.forEach((obj) => {
    if (!uniqueArr.find((item) => comparator(item, obj))) {
      uniqueArr.push(obj);
    }
  });

  return uniqueArr;
};
